export const AI_AGENTS = [
    { name: 'Rebecca', description: 'AI Guest Experience', img: '/assets/agents/rebecca-agent.svg' },
]